// Theme: meadowland
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'meadowland',
  name: 'MEADOWLAND',
  tagline: 'MEADOWLAND',
  description: 'Verde de pradaria em versao free BP com brilho contido.',
  category: 'organic-world',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#132216', '#1E3520', '#86EFAC', '#F0FDF4'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-meadowland'
  },
  colorVars: {
    '--accent': '#86EFAC',
    '--accent-foreground': '#132216',
    '--background': '#132216',
    '--border': '#3A7A45',
    '--card': '#1E3520',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F0FDF4',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#132216',
    '--foreground': '#F0FDF4',
    '--hold-fill': '#86EFAC',
    '--input': '#3A7A45',
    '--modal-bg': '#132216',
    '--modal-border': '#3A7A45',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A7A45',
    '--muted-foreground': '#F0FDF4',
    '--nav-active': '#86EFAC',
    '--nav-bg': '#1E3520',
    '--popover': '#1E3520',
    '--popover-foreground': '#F0FDF4',
    '--primary': '#86EFAC',
    '--primary-foreground': '#132216',
    '--ring': '#86EFAC',
    '--secondary': '#3A7A45',
    '--secondary-foreground': '#F0FDF4',
    '--streak': '#86EFAC',
    '--success': '#22c55e',
    '--success-foreground': '#132216',
    '--xp': '#86EFAC',
    '--xp-bg': '#1E3520'
  },
  resolvedVars: {
    '--accent': '#86EFAC',
    '--accent-foreground': '#132216',
    '--accent-foreground-hsl': '132 28% 10%',
    '--accent-foreground-oklch': 'from #132216 l c h',
    '--accent-hsl': '142 77% 73%',
    '--accent-oklch': 'from #86EFAC l c h',
    '--background': '#132216',
    '--background-hsl': '132 28% 10%',
    '--background-oklch': 'from #132216 l c h',
    '--border': '#3A7A45',
    '--border-hsl': '130 36% 35%',
    '--border-oklch': 'from #3A7A45 l c h',
    '--border-w': '1px',
    '--card': '#1E3520',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F0FDF4',
    '--card-foreground-hsl': '138 76% 97%',
    '--card-foreground-oklch': 'from #F0FDF4 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--card-hsl': '125 28% 16%',
    '--card-oklch': 'from #1E3520 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#132216',
    '--destructive-foreground-hsl': '132 28% 10%',
    '--destructive-foreground-oklch': 'from #132216 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F0FDF4',
    '--foreground-hsl': '138 76% 97%',
    '--foreground-oklch': 'from #F0FDF4 l c h',
    '--hold-fill': '#86EFAC',
    '--hold-fill-hsl': '142 77% 73%',
    '--hold-fill-oklch': 'from #86EFAC l c h',
    '--input': '#3A7A45',
    '--input-hsl': '130 36% 35%',
    '--input-oklch': 'from #3A7A45 l c h',
    '--modal-bg': '#132216',
    '--modal-bg-hsl': '132 28% 10%',
    '--modal-bg-oklch': 'from #132216 l c h',
    '--modal-border': '#3A7A45',
    '--modal-border-hsl': '130 36% 35%',
    '--modal-border-oklch': 'from #3A7A45 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A7A45',
    '--muted-foreground': '#F0FDF4',
    '--muted-foreground-hsl': '138 76% 97%',
    '--muted-foreground-oklch': 'from #F0FDF4 l c h',
    '--muted-hsl': '130 36% 35%',
    '--muted-oklch': 'from #3A7A45 l c h',
    '--nav-active': '#86EFAC',
    '--nav-active-hsl': '142 77% 73%',
    '--nav-active-oklch': 'from #86EFAC l c h',
    '--nav-bg': '#1E3520',
    '--nav-bg-hsl': '125 28% 16%',
    '--nav-bg-oklch': 'from #1E3520 l c h',
    '--popover': '#1E3520',
    '--popover-foreground': '#F0FDF4',
    '--popover-foreground-hsl': '138 76% 97%',
    '--popover-foreground-oklch': 'from #F0FDF4 l c h',
    '--popover-hsl': '125 28% 16%',
    '--popover-oklch': 'from #1E3520 l c h',
    '--primary': '#86EFAC',
    '--primary-foreground': '#132216',
    '--primary-foreground-hsl': '132 28% 10%',
    '--primary-foreground-oklch': 'from #132216 l c h',
    '--primary-hsl': '142 77% 73%',
    '--primary-oklch': 'from #86EFAC l c h',
    '--radius': '10px',
    '--ring': '#86EFAC',
    '--ring-hsl': '142 77% 73%',
    '--ring-oklch': 'from #86EFAC l c h',
    '--secondary': '#3A7A45',
    '--secondary-foreground': '#F0FDF4',
    '--secondary-foreground-hsl': '138 76% 97%',
    '--secondary-foreground-oklch': 'from #F0FDF4 l c h',
    '--secondary-hsl': '130 36% 35%',
    '--secondary-oklch': 'from #3A7A45 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#86EFAC',
    '--streak-hsl': '142 77% 73%',
    '--streak-oklch': 'from #86EFAC l c h',
    '--success': '#22c55e',
    '--success-foreground': '#132216',
    '--success-foreground-hsl': '132 28% 10%',
    '--success-foreground-oklch': 'from #132216 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(142 77% 73% / 0.15)',
    '--xp': '#86EFAC',
    '--xp-bg': '#1E3520',
    '--xp-bg-hsl': '125 28% 16%',
    '--xp-bg-oklch': 'from #1E3520 l c h',
    '--xp-hsl': '142 77% 73%',
    '--xp-oklch': 'from #86EFAC l c h'
  }
}
